import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { Heading, InputMoney, InputRange } from '@warrenbrasil/nebraska-web';

interface Props {
  title: string;
  placeholder?: string;
  modelValue?: number;
  rangeValue?: number;
  min?: number;
  max?: number;
  step?: number;
}

interface Emits {
  (event: 'update:modelValue', value: number): void;
  (event: 'update:rangeValue', value: number): void;
  (event: 'change', payload: { money: number; range: number }): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSliderFilter',
  props: {
    title: null,
    placeholder: { default: 'R$ 0,00' },
    modelValue: { default: 0 },
    rangeValue: { default: 0 },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 }
  },
  emits: ["update:modelValue", "update:rangeValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', value: number): void;
  (event: 'update:rangeValue', value: number): void;
  (event: 'change', payload: { money: number; range: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, placeholder: string, modelValue: number, rangeValue: number, min: number, max: number, step: number };





const internalValue = ref(props.modelValue || 0);
const isMaxValue = computed(() => internalValue.value >= props.max);

const inputMoneyValue = ref(props.modelValue);
const inputRangeValue = ref(props.rangeValue);

watch(
  () => props.modelValue,
  newValue => {
    inputMoneyValue.value = newValue;
  }
);

watch(
  () => props.rangeValue,
  newValue => {
    inputRangeValue.value = newValue;
  }
);

const handleMoneyInput = (value: number) => {
  inputMoneyValue.value = value;
  emit('update:modelValue', value);
  emit('change', {
    money: inputMoneyValue.value,
    range: inputRangeValue.value
  });
};

const handleRangeChange = (value: number) => {
  inputRangeValue.value = value;
  inputMoneyValue.value = value;

  emit('update:rangeValue', value);
  emit('update:modelValue', inputMoneyValue.value);
  emit('change', {
    money: inputMoneyValue.value,
    range: inputRangeValue.value
  });
};

return { __sfc: true,props, emit, internalValue, isMaxValue, inputMoneyValue, inputRangeValue, handleMoneyInput, handleRangeChange, Heading, InputMoney, InputRange }
}

})